enum CommentActionType {
    UserComment = 1,
    Print,
    Fax,
    Sign,
    RevokeSignature = 5,
    SyncToPortal,
    MedicalRequestStatusChange,
    MedicalRequestRecipientChange
}

export { CommentActionType };
